import { useState } from 'react';
import { LatexText } from '../latex';

/** One worked solution from the question document. Structural, so callers can
 *  pass the question-bank `Solution` without this module importing it. */
export interface GivenSolution {
    style?: string;
    proficiencyLevel?: string;
    label?: string;
    targetExams?: string[];
    steps: string;
}

export interface GivenSolutionCardProps {
    solutions?: GivenSolution[] | null;
    title?: string;
    /** Collapsed by default: the reference is consulted, not read every time. */
    defaultCollapsed?: boolean;
}

const PROFICIENCY_TO_STYLE: Record<string, string> = { low: 'detailed', medium: 'formal', high: 'quick' };
const STYLE_LABELS: Record<string, string> = { detailed: 'Detailed', formal: 'Formal', quick: 'Quick' };

/** The solution(s) the question carries, for setting beside the student's work. */
export function GivenSolutionCard({
    solutions,
    title = 'Given Correct Solution',
    defaultCollapsed = true,
}: GivenSolutionCardProps) {
    const [collapsed, setCollapsed] = useState(defaultCollapsed);
    const list = solutions ?? [];

    return (
        <div className="card given-solution-card">
            <button className="card-toggle" onClick={() => setCollapsed(c => !c)} aria-expanded={!collapsed}>
                <span className={`toggle-icon ${collapsed ? 'collapsed' : ''}`}>▼</span>
                <h3>{title}</h3>
                {list.length > 1 && <span className="given-solution-count">{list.length}</span>}
            </button>
            {!collapsed && (
                <div className="given-solution-content">
                    {list.length === 0 && <p className="given-solution-empty">This question has no written solution.</p>}
                    {list.map((sol, idx) => {
                        const style = sol.style || PROFICIENCY_TO_STYLE[sol.proficiencyLevel ?? ''] || 'formal';
                        const tags = [STYLE_LABELS[style] || style, sol.label, sol.targetExams?.join(', ')].filter(Boolean);
                        return (
                            <div key={idx} className="given-solution">
                                {list.length > 1 && <div className="given-solution-tags">{tags.join(' · ')}</div>}
                                <div className="given-solution-steps"><LatexText text={sol.steps} /></div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
